/* Análise → Por categoria: tabela, distribuição e categorias gerais de cada escopo. */

import { api } from '../../core/api';
import { esc, lista, nf, num, pct } from '../../core/formato';
import type { PorCategoria, PorCategoriaGeral } from '../../tipos/api';
import { carregar } from '../../ui/carregar';
import { loading, pillEscopo, rotuloCategoria, tabela } from '../../ui/componentes';
import { setHtml } from '../../ui/dom';
import { filtrosBar, paramsFiltro } from '../../ui/filtros';
import { barrasH } from '../../ui/graficos';
import type { Pagina } from '../pagina';

export const categorias: Pagina = {
  render: () => `
  <h1 class="page">Emissões por categoria</h1>
  <p class="sub">Categorias do GHG Protocol usadas nos lançamentos, somadas a partir das emissões calculadas pela ZNIT.</p>
  ${filtrosBar({ escopo: true })}
  <div class="grid" style="grid-template-columns:minmax(0,1.3fr) minmax(0,1fr);align-items:start">
    <div id="aCatTab">${loading()}</div>
    <div class="card"><h2 class="sec">Distribuição</h2><div id="aCatBar">${loading()}</div></div>
  </div>
  <h2 class="sec" style="margin-top:30px">Categorias gerais por escopo</h2>
  <div class="grid g3">${[1, 2, 3].map((e) => `<div class="card"><div style="margin-bottom:14px">${pillEscopo(e)}</div><div id="aEsc${e}">${loading()}</div></div>`).join('')}</div>`,

  carregar(tk) {
    carregar(tk, [
      {
        id: 'aCatTab', tambem: ['aCatBar'],
        busca: () => api<PorCategoria[]>('GET', '/por-categoria', { params: paramsFiltro() }),
        html: (d: PorCategoria[]) => {
          const l = lista<PorCategoria>(d);
          const tot = l.reduce((a, x) => a + num(x.total_emissoes), 0);
          setHtml('aCatBar', barrasH(l.slice(0, 8).map((x) => ({ l: rotuloCategoria(x.categoria_de_emissoes), v: num(x.total_emissoes), c: `var(--esc${x.escopo || 1})` }))));
          return tabela<PorCategoria>([
            { l: 'Categoria', f: (x) => `<div style="font-weight:600">${esc(rotuloCategoria(x.categoria_de_emissoes))}</div><div style="margin-top:4px">${pillEscopo(x.escopo)}</div>` },
            { l: 'Lançamentos', r: true, f: (x) => nf(x.quantidade_registros, 0) },
            { l: 'tCO₂e', r: true, f: (x) => `<b>${nf(x.total_emissoes, 2)}</b>` },
            { l: '%', r: true, f: (x) => pct(x.total_emissoes, tot) },
          ], l, ['Total', nf(l.reduce((a, x) => a + num(x.quantidade_registros), 0), 0), nf(tot, 2), l.length ? '100%' : '—']);
        },
      },
      ...[1, 2, 3].map((e) => ({
        id: `aEsc${e}`,
        busca: () => api<PorCategoriaGeral[]>('GET', `/por-escopo/${e}`, { params: paramsFiltro({ escopo: undefined }) }),
        html: (d: PorCategoriaGeral[]) => barrasH(lista<PorCategoriaGeral>(d).slice(0, 6).map((x) => ({
          l: rotuloCategoria(x.categoria_geral_emissoes), v: num(x.total_emissoes), c: `var(--esc${e})`,
        }))),
      })),
    ]);
  },
};
